import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const RadioactiveIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 14.223 12.832"
    >
      <defs>
        <clipPath>
          <rect
            width="14.223"
            height="12.832"
            transform="translate(0 -0.001)"
            fill="none"
            stroke={color}
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <circle
            cx="4.176"
            cy="4.176"
            r="4.176"
            transform="translate(0.5 3.98)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <circle
            cx="4.176"
            cy="4.176"
            r="4.176"
            transform="translate(5.372 3.98)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <circle
            cx="4.176"
            cy="4.176"
            r="4.176"
            transform="translate(2.936 0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
